import { Container, Row, Col, Breadcrumb } from "react-bootstrap";
import { CTA, BackLink, Description, Title } from "@/ui";
import clsx from "classnames";
import classes from "./styles.module.scss";
import { DynamicImage } from "@/ui/DynamicImage";
import { useRouter } from "next/router";
import { getNestedRoutes } from "@/functions/getNestedRoutes";
import { ensureTrailingSlash } from "@/functions/ensureTrailingSlash";

export default function HeaderSideImage({
  className,
  bgColor,
  img,
  title,
  titleColor,
  reading_time,
  description,
  button = null,
  backLink,
  back,
}) {
  const router = useRouter();
  const url_slugs = router.asPath.split("/").slice(1, -1);
  //const pages = getNestedRoutes({ url_slugs });
  const pages = getNestedRoutes({
    url_slugs,
    overwrites: {
      "recruitment-solutions": { href: "/recruitment-solutions/why-choose-blue-arrow/" },
    },
  });

  return (
    <>
      {pages && (
        <div className={clsx(className, classes.breadcrumbs)}>
          <Container className="mw-xxl">
            <Breadcrumb>
              <Breadcrumb.Item href={"/"}>Home</Breadcrumb.Item>
              {pages.map(({ label, href }, k) => (
                <Breadcrumb.Item key={k} href={ensureTrailingSlash(href)}>
                  {label}
                </Breadcrumb.Item>
              ))}
            </Breadcrumb>
          </Container>
        </div>
      )}
      <div className={clsx(className, bgColor, classes.header, "text-tertiary")}>
        <Container fluid className="mw-xxl">
          <Row>
            <Col xs={12} md={6} className={clsx(classes.header__content, "py-5")}>
              {backLink?.href && <BackLink back={backLink} />}
              <Title className={clsx(titleColor, "mb-0")} title={title} tag="h1" />
              <Title
                className={"mt-5 mb-0 px-3 py-2 d-inline border border-2 border-tertiary rounded-5"}
                title={reading_time}
                tag="span"
              />
              <div className="description me-4">
                <Description className="mt-4" description={description} />
                {button && button?.label && (
                  <CTA className="mt-5" label={button?.label} href={button?.href} variant={button?.variant} />
                )}
              </div>
            </Col>
            <Col xs={12} md={6} className="px-0">
              <DynamicImage image={img} />
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}
